import { makeStyles } from '@mui/styles';

const useWidgetStyles = makeStyles(() => ({
  saveBtn: {
    marginBottom: '30px !important',
  },
}));

export default useWidgetStyles;
